import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  MobileStepper,
  Typography,
  IconButton,
  Button,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import CloseIcon from "@mui/icons-material/Close";

const HelpInstructions = ({ open, onClose }) => {
  const [activeStep, setActiveStep] = useState(0);
  const { t } = useTranslation();

  const steps = [
    t("dashboard.helpInstructions.heading"),
    t("dashboard.helpInstructions.heading"),
  ];

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const dialogStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backdropFilter: "blur(5px)",
  };

  const contentStyle = {
    textAlign: "center",
    position: "relative",
  };

  const closeButtonStyle = {
    position: "absolute",
    top: 0,
    right: 0,
    margin: "16px", // Add margin as needed
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      style={dialogStyle}
      maxWidth="md"
      fullWidth={true}
    >
      {/* Close button */}
      <IconButton
        edge="end"
        color="inherit"
        onClick={onClose}
        style={closeButtonStyle}
        aria-label="close"
      >
        <CloseIcon />
      </IconButton>
      {/* <DialogTitle color={appColours.lightGreen}>Instructions</DialogTitle> */}
      <DialogContent>
        {/* Display current step */}
        <Typography variant="h5" gutterBottom fontWeight={700}>
          {steps[activeStep]}
        </Typography>

        {/* Add your instruction content based on the current step */}
        {activeStep === 0 && (
          <>
            <Typography variant="h6" gutterBottom fontWeight={400}>
              {t("dashboard.helpInstructions.help1.description")}
            </Typography>

            <img
              src="/assets/images/how_it_works/help-image1.png"
              alt="help-img-1"
              width="550px"
              height="400px"
              style={{ display: "block", margin: "auto" }}
            />
          </>
        )}
        {activeStep === 1 && (
          <>
            <Typography variant="h6" gutterBottom fontWeight={400}>
              {t("dashboard.helpInstructions.help2.description")}
            </Typography>

            <img
              src="/assets/images/how_it_works/help-image2.png"
              alt="help-img-2"
              width="750px"
              height="500px"
              style={{ display: "block", margin: "auto" }}
            />
          </>
        )}
        {/* Add more steps as needed */}

        {/* Mobile Stepper */}
        <MobileStepper
          variant="dots"
          steps={steps.length}
          position="static"
          activeStep={activeStep}
          nextButton={
            <Button
              size="small"
              onClick={handleNext}
              disabled={activeStep === steps.length - 1}
            >
              {t("dashboard.helpInstructions.nextBtn")}
              <KeyboardArrowRight />
            </Button>
          }
          backButton={
            <Button
              size="small"
              onClick={handleBack}
              disabled={activeStep === 0}
            >
              <KeyboardArrowLeft />
              {t("dashboard.helpInstructions.prevBtn")}
            </Button>
          }
        />
      </DialogContent>
    </Dialog>
  );
};

export default HelpInstructions;
